// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"92d24996","283":"fcba1591","558":"0652d030","574":"79e7e656","818":"01ac76e4","850":"51ccba61","938":"9aebe594"}[chunkId] + ".chunk.js";
};